// 역할 상수 (DB roles.name 값과 일치)
export const VENDOR_ROLE = {
    SUPPLIER: '도매', // 도매 - 소매업자 대상
    RESELLER: '소매', // 소매 - 일반 소비자 대상
} as const;

export type VendorRoleType = (typeof VENDOR_ROLE)[keyof typeof VENDOR_ROLE];

// 역할별 기능 설정
export interface VendorRoleFeatures {
    // 장바구니
    hasCart: boolean; // 장바구니 기능 유무
    cartType: 'spacehome' | 'shop3'; // 장바구니 타입

    // 주문/결제
    paymentType: 'pg' | 'cash'; // PG 결제 vs 캐시 결제

    // 가격
    priceField: 'productCharge' | 'supplyPrice'; // 사용할 가격 필드

    // 기타 기능
    sampleRequest: boolean; // 샘플 요청 (도매만)
    bulkOrder: boolean; // 대량 주문 (도매만)
}

export interface VendorRoleConfig {
    label: string;
    buyerType: string;
    features: VendorRoleFeatures;
}

export const VENDOR_ROLE_CONFIG: Record<VendorRoleType, VendorRoleConfig> = {
    [VENDOR_ROLE.SUPPLIER]: {
        label: '도매',
        buyerType: '소매업자',
        features: {
            hasCart: true,
            cartType: 'shop3',
            paymentType: 'cash',
            priceField: 'supplyPrice',
            sampleRequest: true,
            bulkOrder: true,
        },
    },
    [VENDOR_ROLE.RESELLER]: {
        label: '소매',
        buyerType: '일반 소비자',
        features: {
            hasCart: true,
            cartType: 'spacehome',
            paymentType: 'pg',
            priceField: 'productCharge',
            sampleRequest: false,
            bulkOrder: false,
        },
    },
};

// 유틸리티 함수
export const isSupplier = (role?: VendorRoleType | null): boolean => role === VENDOR_ROLE.SUPPLIER;

export const isReseller = (role?: VendorRoleType | null): boolean => role === VENDOR_ROLE.RESELLER;

// 가격 필드 헬퍼
export const getPriceField = (role?: VendorRoleType | null): 'productCharge' | 'supplyPrice' =>
    isSupplier(role) ? 'supplyPrice' : 'productCharge';
